import React from 'react';
import { Calendar, Badge } from 'antd';
import './leaveCalendar.css';
import axios from 'axios';
import moment from 'moment';

const API_HOST_URL = process.env.REACT_APP_API_URL

class LeaveCalendar extends React.Component{

state = {
  leaveRequests: [],
}

componentDidMount(){
  this.fetchLeaveRequests();
}

fetchLeaveRequests = () => {
  let mapResults = [];
    axios.get(`${API_HOST_URL}/api/leave/leaverequest/?expand=employee&expand=leaveType&status=Approved`)
      .then(res => {
        this.setState({
          leaveRequests: res.data
        })
        console.log("Leave requests: ",res.data)
        mapResults = res.data.map(item => ({type: 'error', content: item.note}));
        console.log("mapResults: ", mapResults)
      })
}

getListData = (value) => {
  let listData = [];

  this.state.leaveRequests.forEach(item => {
    
    let from_date = moment(item.fromDate);
    let to_date = moment(item.toDate);

    let from_day = moment(item.fromDate).date() - 1;
    let to_day = (moment(item.toDate).date())-1;
    
    let from_month = moment(item.fromDate).month()+1;
    let to_month = moment(item.toDate).month()+1;

    let from_year = moment(item.fromDate).year();
    let to_year = moment(item.toDate).year();

    if(from_year == value.year() && from_month == value.month()+1){
        if(value.date() >= from_day && value.date() <= to_day){
          listData.push({type: 'error', content: item.employee.firstName + ' ' +item.employee.lastName })
        }
    }
  });  

  return listData || [];
}

 dateCellRender = (value) => {
  const listData = this.getListData(value);
  return (
    <ul className="events">
      {
        listData.map(item => (
          <li key={item.content}>
            <Badge status={item.type} text={item.content} />
          </li>
        ))
      }
    </ul>
  );
}

getMonthData = (value) => {
  if (value.month() === 8) {
    return 1394;
  }
}

monthCellRender = (value) => {
  const num = this.getMonthData(value);
  return num ? (
    <div className="notes-month">
      <section>{num}</section>
      <span>Backlog number</span>
    </div>
  ) : null;
}

render(){
    return(
        <Calendar dateCellRender={this.dateCellRender} monthCellRender={this.monthCellRender} />
    );
}

}

export default LeaveCalendar;